import { view } from '@yola/ws-sdk';
import selectors from '../../../common/constants/selectors';
import calculateDuplicatedItemPosition from './calculate-duplicated-item-position';
import calculateNewItemPosition from './calculate-new-item-position';
import calculateCreationSequence from './calculate-creation-sequence';
import constants from '../constants/common';

const POSITION = 'position';
const { DATA_CREATION_SEQUENCE_ATTRIBUTE } = constants;

function duplicateCompositeItem({ elementId }) {
  const compositeItemLiveNode = view.accessors.getLiveElement(elementId);
  const compositeGroupLiveNode = compositeItemLiveNode.closest(selectors.COMPOSITE_GROUP);

  const compositeGroupElementId = view.accessors.getLiveElementId(compositeGroupLiveNode);
  const compositionGroup = view.accessors.getStaticElement(compositeGroupElementId);
  const compositeItem = view.accessors.getStaticElement(elementId);

  const clonedCompositeItem = compositeItem.cloneNode(true);
  const isPinedToBottomRightCorner = compositeItem
    .getAttribute(POSITION)
    .split(' ')
    .every((value) => value === '100%');

  const position = isPinedToBottomRightCorner
    ? calculateNewItemPosition(compositionGroup)
    : calculateDuplicatedItemPosition(clonedCompositeItem);

  const dataCreationSequence = calculateCreationSequence(compositionGroup);

  clonedCompositeItem.setAttribute(POSITION, position);
  clonedCompositeItem.setAttribute(DATA_CREATION_SEQUENCE_ATTRIBUTE, dataCreationSequence);
  compositionGroup.appendChild(clonedCompositeItem);

  view.operations.replaceElement(compositionGroup, compositeGroupElementId);
}

export default duplicateCompositeItem;
